<template>
    <div class="mb-3">
        <div class="tab-content">
            <ul class="nav nav-tabs mb-3" role="tablist">
                <li class="nav-item" v-for="(lang, index) in getTranslations" :key="index">
                    <a
                        :aria-selected="active(lang) ? 'true' : 'false'"
                        :id="blockIndex+'-'+lang+'-'+index+'-tab'"
                        :href="'#tab-'+blockIndex+'-'+lang+'-'+index"
                        :aria-controls="'tab-'+blockIndex+'-'+lang+'-'+index"
                        data-toggle="tab"
                        role="tab"
                        class="nav-link"
                        :class="[getErrorTab(lang) ? 'text-danger font-weight-bolder': '', active(lang) ? 'active' : '']"
                        >{{ lang.toUpperCase() }}</a>
                </li>
            </ul>

            <div
                :id="'tab-'+blockIndex+'-'+lang+'-'+index"
                role="tabpanel"
                :aria-labelledby="+blockIndex+'-'+lang+'-'+index+'-tab'"
                class="tab-pane fade"
                :class="active(lang) ? 'show active' : ''"
                v-for="(lang, index) in getTranslations" :key="index"
                >
                <div class="form-row">
                    <input-element v-model="block.translations[lang].title" :error="getErrorTranslation(lang, 'title')" label="Title" :name="'title-'+blockIndex+'-'+lang+'-'+index" :required="true"></input-element>
                </div>

                <div class="form-row">
                    <textarea-element  v-model="block.translations[lang].content" :error="getErrorTranslation(lang, 'content')" label="Content" :name="'content-'+blockIndex+'-'+lang+'-'+index" :required="false"></textarea-element>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputElement from "../form-elements/Input.vue";
import TextareaElement from "../form-elements/Textarea.vue";
import ErrorTab from "../../mixins/ErrorTab.js"
import ErrorTranslation from "../../mixins/ErrorTranslation.js"
import GetTranslations from "../../mixins/GetTranslations.js"
import Active from "../../mixins/Active.js"

export default {
    components: {
        InputElement,
        TextareaElement,
    },
    mixins: [ErrorTab, ErrorTranslation, GetTranslations, Active],
    props: {
        block:Object,
        index:Number,
        locale:String,
    },
    data() {
        return {
            blockIndex: this.index,
        }
    },
}
</script>